module.exports = __webpack_public_path__ + "media/luxury-2026/pool-architecture-960-dd0291af.jpg";